import { ApiError } from "@/api/client";

const MESSAGES: Record<string, string> = {
  INVALID_OTP: "That code isn't right. Check the email and try again.",
  OTP_EXPIRED: "That code has expired. Send a new one.",
  TOO_MANY_ATTEMPTS: "Too many attempts. Send a new code.",
  ACCOUNT_LOCKED: "This account can't sign in.",
  handle_taken: "That handle is taken.",
  handle_reserved: "That handle is reserved.",
  handle_invalid: "Use 3–20 letters, numbers or _.",
  identity_already_claimed: "This account already has a profile.",
  forbidden: "That request was blocked. Reload the page and try again.",
};

/** User-facing copy for auth and identity errors (server codes and Better Auth codes). */
export function authErrorMessage(error: unknown, fallback = "Something went wrong. Try again."): string {
  if (error instanceof ApiError) {
    if (error.status === 429) return "Too many attempts. Wait a minute and try again.";
    if (error.code && MESSAGES[error.code]) return MESSAGES[error.code]!;
    if (error.status === 400 && error.message) return error.message;
    return fallback;
  }
  if (error instanceof TypeError) return "Can't reach Studside. Check your connection and try again.";
  return fallback;
}

/** The claim field the server rejected, if any (`{ field: "handle" }`). */
export function errorField(error: unknown): string | undefined {
  if (!(error instanceof ApiError) || typeof error.body !== "object" || error.body === null) return undefined;
  const field = (error.body as { field?: unknown }).field;
  return typeof field === "string" ? field : undefined;
}
